import React from "react";
import { useTranslation } from "react-i18next";
import * as moment from "moment";
import { FiChevronRight } from "react-icons/fi";
import { GiSoccerBall, GiStrikingArrows } from "react-icons/gi";

const Card = ({ data }) => {
  const { t } = useTranslation();
  const status = String(data?.status || "Pending");
  const normalizedStatus = status.toLowerCase();
  const statusStyle = normalizedStatus.includes("win")
    ? "border-emerald-300/20 bg-emerald-300/15 text-emerald-200"
    : normalizedStatus.includes("lose") || normalizedStatus.includes("loss")
    ? "border-red-300/20 bg-red-300/15 text-red-400"
    : "border-amber-300/20 bg-amber-300/15 text-amber-400";
  const isMix = data?.gamblingTypeId === 2;

  const formatAmount = (value) =>
    Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

  return (
    <article className="rounded-lg border border-primary/40 bg-header_green/50 p-4 shadow-lg shadow-black/10 transition hover:border-white/25 hover:bg-header_green/65 active:scale-[0.99]">
      <div className="flex items-start justify-between gap-3 border-b border-white/10 pb-3">
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-white/10 text-emerald-100">
            {isMix ? (
              <GiStrikingArrows className="h-5 w-5" />
            ) : (
              <GiSoccerBall className="h-5 w-5" />
            )}
          </div>
          <div className="min-w-0">
            <h2 className="text-sm font-semibold leading-[1.8] text-white">
              {isMix ? t("maungg") : t("body")}
            </h2>
            <p className="font-sans text-[11px] text-white/40">
              {moment(data?.createdDate).format("DD MMM YYYY • h:mm A")}
            </p>
          </div>
        </div>
        <div className="flex flex-none items-center gap-1.5">
          <span
            className={`rounded-md border px-2.5 py-1 font-sans text-[10px] font-semibold uppercase tracking-wide ${statusStyle}`}
          >
            {status}
          </span>
          <FiChevronRight className="h-4 w-4 text-white/30" />
        </div>
      </div>

      <div className={`mt-3 grid gap-2 ${isMix ? "grid-cols-3" : "grid-cols-2"}`}>
        <InfoItem label={t("betAmount")} value={formatAmount(data?.amount)} />
        {isMix && <InfoItem label={t("teamCount")} value={data?.teamCount || 0} />}
        <InfoItem
          label={t("profitAmount")}
          value={formatAmount(Math.max(0, Number(data?.profitAmount || 0)))}
          highlighted
        />
      </div>
    </article>
  );
};

const InfoItem = ({ label, value, highlighted }) => (
  <div className="min-w-0 rounded-lg bg-black/15 px-3 py-2.5">
    <p className="truncate text-[10px] leading-[1.8] text-white/45">{label}</p>
    <p
      className={`mt-1 truncate font-sans text-sm font-semibold ${
        highlighted ? "text-emerald-200" : "text-white"
      }`}
    >
      {value}
    </p>
  </div>
);

export default Card;
